import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ApiService } from './ApiService';
import { Urls } from './urls';

@Injectable({ providedIn: 'root' })
export class RolesService {
  constructor(private http: HttpClient, private apiService: ApiService) {}

  getMyRoles(): Observable<any> {
    return this.apiService.getPetition(Urls.urls.roles);
  }

  createRole(data: { name: string; description?: string }): Observable<any> {
    return this.apiService.save(Urls.urls.roles, data);
  }

  updateRole(id: number, data: { name?: string; description?: string }): Observable<any> {
    return this.apiService.save(Urls.urls.roles, data, id);
  }

  deleteRole(id: number): Observable<any> {
    return this.apiService.deleteById(Urls.urls.roles, id);
  }

  getRolePanels(roleId: number): Observable<any> {
    return this.apiService.getPetition(`${Urls.urls.roles}/${roleId}/panels`);
  }

  syncRolePanels(roleId: number, panels: any[]): Observable<any> {
    return this.http.post(`${Urls.urls.roles}/${roleId}/panels`, { panels });
  }

  getAllPanels(): Observable<any> {
    return this.apiService.getPetition(Urls.urls.panels);
  }
}
